module.exports = __webpack_public_path__ + "img/ArticlesofAssociationorAnnualReturnhongkong.c368d604.jpg";